<template>
    <div class="layout--application">
        <navigation-menu />

        <application-toolbar />

        <!-- the "slot" will contain all the markup from the View's template tag (usually starting with v-content) -->
        <slot />

        <app-snackbar />
        <modal-session-notice />
    </div>
</template>

<script>
import AppSnackbar from "@/components/global/AppSnackbar.vue";
import ApplicationToolbar from "@/components/ApplicationToolbar.vue";
import ModalSessionNotice from "@/components/ModalSessionNotice.vue";
import NavigationMenu from "@/components/NavigationMenu.vue";

export default {
  components: {
    AppSnackbar,
    NavigationMenu,
    ApplicationToolbar,
    ModalSessionNotice
  }
};
</script>

<style lang="scss">
    @import "../assets/sass/editor-content";
    @import "../assets/sass/editor-dark";
    @import "../assets/sass/icons";
</style>
